export const name = 're-shop-products-item-reservation'

import {
  mixins as baseMixins,
  props,
  validationsRules,
  defaultFormFields,
  data,
  EventBus
} from '../base/config'

// mixins
import ReservationMixin from '../../../../../../mixins/shop/reservation'
const mixins = [...baseMixins, ReservationMixin]

export {
  mixins,
  props,
  validationsRules,
  defaultFormFields,
  data,
  EventBus
}

export default {
  name,
  mixins,
  props,
  data,
  EventBus,
}
